import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
  label: {
    fontWeight: 'bold',
    color: '#596375',
    fontSize: '14px',
    margin: '5px 0'
  },

  searchContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #ced4da',
    borderRadius: '4px',
    background: '#D8D8D8'
  },

  textField: {
    width: '90%',

    '& > div': {
      border: 'none',
      borderRadius: '4px 0 0 4px',
      borderRight: '1px solid #ced4da'
    },

    '& > div::after': {
      display: 'none'
    }
  }
});
